import React from 'react';
import classNames from 'classnames';
import Image from '../../elements/Image';

interface LogoCloudMigrationSpecBadgeProps {
  className?: string;
  width?: number;
  height?: number;
}

const defaultProps: LogoCloudMigrationSpecBadgeProps = {
  width: 170,
  height: 60,
};

const LogoCloudMigrationSpecBadge: React.FC<LogoCloudMigrationSpecBadgeProps> = ({
  className,
  width,
  height,
  ...props
}) => {
  const classes = classNames('brand', className);

  return (
    <div {...props} className={classes}>
      <h1 className="m-0">
        <Image
          src={require('../../../assets/images/cloud-migration-emea-white.svg')}
          alt="Cloud Migration Specialization EMEA"
          width={width}
          height={height}
        />
      </h1>
    </div>
  );
};

LogoCloudMigrationSpecBadge.defaultProps = defaultProps;

export default LogoCloudMigrationSpecBadge;
